<div
  class="admin-selection-action-menu"
  [ngClass]="selectedItems.length > 0 ? 'admin-selection-action-menu-active' : 'admin-selection-action-menu-disabled'"
  (click)="toggleActions()"
  (keydown)="null"
>
  <label>
    {{'TRANS__SEARCH__ACTION_MENU__SECTION_TITLE__PROCESS_SELECTION' | translate}} ({{selectedItems.length}})
  </label>

  <i class="material-icons">keyboard_arrow_down</i>
</div>

<!-- Popup container for actions -->
@if(showActions) {
  <div
    class="action-popup-overlay"
    (click)="closeActionPopup()"
    (keydown)="null"
  ></div>

  <div class="action-popup">
    <ng-content></ng-content> <!-- Projected action items here -->
  </div>
}
